import React from 'react';
import { Box, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { adminCombineSx, adminFormRowSx } from '../../styles/adminComponentStyles';

type AdminFormRowProps = {
  children: React.ReactNode;
  label: string;
  required?: boolean;
  sx?: SxProps<Theme>;
};

const AdminFormRow: React.FC<AdminFormRowProps> = ({ children, label, required = false, sx }) => (
  <Box sx={adminCombineSx(adminFormRowSx, sx)}>
    <Typography className="AdminFormRow-label" component="div">
      {label}
      {required ? (
        <Box className="AdminFormRow-required" component="span">
          {' '}*
        </Box>
      ) : null}
    </Typography>
    <Box className="AdminFormRow-field">{children}</Box>
  </Box>
);

export default React.memo(AdminFormRow);
